import styles from './PersonalFilesPage.module.css';
import SearchBar from '../../../components/SearchBar/SearchBar';
import Dropdown from '../../../components/Dropdown/Dropdown';

import Dynamic from '../../../components/DynamicTable/DynamicTable';
import { useDispatch } from 'react-redux';
import { openModal } from '../../../redux/slices/modalSlice';
import { useState } from 'react';
import PaginationTable from '../../../components/PaginationTable/PaginationTable';
import Action from '../../../components/Action/Action';
import defaultPhoto from '../../../assets/images/Dailyactivityphoto.png'; // Replace with your file icon image
import IconAndName from '../../../components/IconAndName/IconAndName';
import { FaFileAlt } from 'react-icons/fa';

const data = [
  {
    _id: '1',
    documentName: 'Logo.png',
    updatedBy: 'Darshan',
    documentIcon: defaultPhoto,
    actionOptions: ['Edit', 'Delete'],
  },
  {
    _id: '2',
    documentName: 'Report.pdf',
    updatedBy: 'Darshan',
    documentIcon: defaultPhoto,
    actionOptions: ['Edit', 'Delete'],
  },
  {
    _id: '3',
    documentName: 'StudentList.xlsx',
    updatedBy: 'Darshan',
    documentIcon: defaultPhoto,
    actionOptions: ['Edit', 'Delete'],
  },
  {
    _id: '4',
    documentName: 'Notes.docx',
    updatedBy: 'Darshan',
    documentIcon: defaultPhoto,
    actionOptions: ['Edit', 'Delete'],
  },
];

function PersonalFilesPage() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);

  const getColumnData = (data) => {
    return data?.map((item) => {
      const isChecked = selectedIds.includes(item._id);
      return {
        checkBox: (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => {
              const checked = e.target.checked;
              setSelectedIds((prev) =>
                checked
                  ? [...prev, item._id]
                  : prev.filter((id) => id !== item._id)
              );
            }}
          />
        ),
        documentName: (
          <div className={styles.documentContainer}>
            <img src={item.documentIcon} alt="Image" />
            <span>{item.documentName}</span>
          </div>
        ),
        updatedBy: item.updatedBy,
        action: (
          <Action
            key={item._id}
            options={item.actionOptions}
            onSelect={(opt) => {
              if (opt === 'Edit') {
                dispatch(openModal('editDocument'));
              } else if (opt === 'Delete') {
                dispatch(openModal('delete'));
              }
            }}
          />
        ),
      };
    });
  };

  const displayData = getColumnData(data);

  const headingsData = [
    {
      title: (
        <input
          type="checkbox"
          checked={selectedIds.length === data.length}
          onChange={(e) => {
            const checked = e.target.checked;
            if (checked) {
              const allIds = data.map((item) => item._id);
              setSelectedIds(allIds);
            } else {
              setSelectedIds([]);
            }
          }}
        />
      ),
      accessor: 'checkBox',
    },
    { title: 'Document Name', accessor: 'documentName' },
    { title: 'Updated By', accessor: 'updatedBy' },
    { title: 'Action', accessor: 'action' },
  ];

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.headerContainer}>
        <div className={styles.totalstudentcard}>
          {/* Filters & Search */}
          <div className={styles.studentsection}>
            <div className={styles.search}>
              <SearchBar placeholder="Search Files" />
            </div>
            <div className={styles.filters}>
              <Dropdown label="All" options={['Document', 'Folders']} />
              <IconAndName
                title={'Add Folder'}
                onClick={() => dispatch(openModal({ type: 'editDocument' }))}
              />
              <IconAndName
                icon={<FaFileAlt size={18} />}
                title={'Add Document'}
                onClick={() => dispatch(openModal({ type: 'addDocument' }))}
              />
            </div>
          </div>

          {/* Table */}
          <div className={styles.dynamicdata}>
            <Dynamic
              headings={headingsData}
              columnData={displayData.slice(
                (currentPage - 1) * itemsPerPage,
                currentPage * itemsPerPage
              )}
            />
          </div>

          {/* Pagination */}
          <div className={styles.paginationTable}>
            <PaginationTable
              data={displayData}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              setCurrentPage={setCurrentPage}
              setItemsPerPage={setItemsPerPage}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PersonalFilesPage;
